import './RouterLoader.scss';
import { Loading } from '@carbon/react';
import React from 'react';

export const RouterLoader = (): React.ReactElement => (
  <div className="bp-router-loader">
    <Loading className="bp-router-loader__spinner" withOverlay={false}/>
  </div>
);
